export default __webpack_public_path__ + "static/media/arrow-left-circle-fill.b1736c90.svg";